export default __webpack_public_path__ + "static/media/pot@2x.d7d93145.png";